// @ts-nocheck
export default defineNuxtPlugin({
  name: 'twitter-pixel',
  parallel: true,
  setup(nuxtApp) {
    if (import.meta.server) {
      return;
    }

    const inject = () => {
      (function (e, t, n) {
        let twq = e.twq;
        twq ??= e.twq = function (...args) {
          if (twq.exe) {
            twq.exe(...args);
          } else {
            twq.queue.push(args);
          }
        };
        twq.version = '1.1';
        twq.queue = [];
        const script = t.createElement(n);
        script.async = !0;
        script.src = 'https://static.ads-twitter.com/uwt.js';
        const firstScript = t.getElementsByTagName(n)[0];
        firstScript.parentNode.insertBefore(script, firstScript);
      })(globalThis, document, 'script');

      globalThis.twq('config', 'o5499');
    };

    const waitIdle = () =>
      new Promise(r =>
        'requestIdleCallback' in globalThis
          ? requestIdleCallback(() => r(undefined))
          : setTimeout(r, 0),
      );

    nuxtApp.hooks.hookOnce('page:finish', () => {
      void (async () => {
        await waitIdle();

        inject();
      })();
    });
  },
});
